"use client";

import { memo, useEffect } from "react";
import { Link, type TSideMenu } from "@/components";
import { useCallback, useState } from "react";

type SideMenuProps = {
	readonly items: TSideMenu[];
	readonly selected?: TSideMenu;
};

/**
 * Displays a list of provided menu items
 * @constructor
 */
function SideMenu(props: SideMenuProps) {
	const [selectedItem, setSelectedItem] = useState<TSideMenu | undefined>(
		props.selected
	);

	useEffect(() => {
		setSelectedItem(props.selected);
	}, [props.selected]);

	return (
		<ul className="list-none" data-testid="cms-side-menu">
			{props.items.map((item) => {
				return (
					<li key={item.id} data-testid={`cms-side-menu-item-${item.label}`}>
						<Link
							className={`
								flex items-center gap-2 border-b-2 py-4 text-sm font-semibold
								hover:cursor-pointer
								hover:border-b-[#00427A] hover:text-[#00427A]
								${item.id === selectedItem?.id ? " border-b-[#0067B9] text-[#0067B9]" : "border-b-transparent"}
							`}
							href={item.url}
							data-testid={`cms-side-menu-item-${item.label}-link`}
						>
							<item.icon
								data-testid={`cms-side-menu-item-${item.label}-icon`}
							/>
							{item.label}
						</Link>
					</li>
				);
			})}
		</ul>
	);
}

export default memo(SideMenu);
